export default function Game_Intro() {
  return (
    <div>
      <h1>Game_Intro Component</h1>
    </div>
  );
}
